import { Component, OnInit, signal, WritableSignal } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
    selector: 'apcam-footer',
    templateUrl: './footer.component.html',
    styleUrl: './footer.component.scss',
    imports: [TranslatePipe],
})
export class FooterComponent implements OnInit {
    currentYear: WritableSignal<number> = signal(0);

    constructor(private readonly analyticsService: AnalyticsService) {}

    ngOnInit(): void {
        this.currentYear.set(new Date().getFullYear());
        this.analyticsService.trackEvent(
            'footer loaded',
            'footer loaded into view',
            'load'
        );
    }
}
